import { render, staticRenderFns } from "./Orientacao.vue?vue&type=template&id=968be4bc&scoped=true"
import script from "./Orientacao.vue?vue&type=script&lang=js"
export * from "./Orientacao.vue?vue&type=script&lang=js"
import style0 from "./Orientacao.vue?vue&type=style&index=0&id=968be4bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968be4bc",
  null
  
)

export default component.exports